/* unplugin-vue-components disabled */import script from "./xqueryLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./xqueryLayout.vue?vue&type=script&setup=true&lang=js"

import "./xqueryLayout.vue?vue&type=style&index=0&id=4bfb1eef&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4bfb1eef"]])

export default __exports__